import React, { Component } from "react";

import CustomText from "../../DocumentItems/CustomText";
import CustomImage from "../../DocumentItems/CustomImage";
import Table from "../../RevvTable";
import getEditorHTML from "../../RevvEditor/getEditorHtml";

class DocumentView extends Component {
  _getSectionView = section => {
    const { mode } = this.props;
    if (section.type === "HTML") {
      const previewSection = {
        ...section,
        html: getEditorHTML(
          section.currentContent || section.data,
          mode || "PREVIEW",
        ),
      };
      return <CustomText key={section.id} section={previewSection} isLocked />;
    }
    if (section.type === "Image") {
      return <CustomImage key={section.id} section={section} isLocked />;
    }
    if (section.type === "Table") {
      return (
        <Table
          key={section.id}
          section={section}
          headers={[]}
          isLocked
          readOnly
        />
      );
    }
    return null;
  };

  render() {
    const { sectionList } = this.props;
    return (
      <div className="document-view doc-preview-document">
        {sectionList.map(section => this._getSectionView(section))}
      </div>
    );
  }
}

export default DocumentView;



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationTopbarBtns/DocumentView.js